import { Workbook } from 'exceljs'
import LogService from '../support/LogService'
import { STRING } from '@/types/GeneralConstants'

enum FILE_EXTENSION {
  XLSX = 'xlsx',
  XLS = 'xls',
  CSV = 'csv',
  TSV = 'tsv',
  TAB = 'tab'
}

const ReadExcel = {
  readFile: async function (file: File): Promise<{ headers: string[], rows: string[][] }> {
    let headers: string[] = []
    const rows: string[][] = []
    try {
      const data = await file.arrayBuffer()
      let sizeHeader = 0
      const workbook = new Workbook().xlsx.load(data)
      const workSheet = (await workbook).worksheets[0]
      workSheet?.eachRow({ includeEmpty: false }, (row, rowIndex) => {
        if (rowIndex === 1) {
          row.eachCell({ includeEmpty: true }, (cell) => {
            headers.push(cell.value ? cell.value.toString() : STRING.EMPTY_STRING)
            if (cell.value) sizeHeader++
          })
        } else {
          const rowData: string[] = []
          row.eachCell({ includeEmpty: true }, (cell, cellIndex) => {
            if (cellIndex <= headers.length && headers[cellIndex - 1] !== STRING.EMPTY_STRING) {
              rowData.push(cell.value != null ? `${cell.value}` : STRING.EMPTY_STRING)
            }
          })
          rows.push(rowData.concat(Array(sizeHeader - rowData.length).fill(STRING.EMPTY_STRING)))
        }
      })
      headers = headers.filter(header => header !== STRING.EMPTY_STRING)
      return { headers, rows }
    } catch (error) {
      LogService.error(`Error en el proceso del archivo ${error}`)
      return { headers, rows }
    }
  }
}

const ReadTSV = {
  stringRowToArray: function (row: string): string[] {
    const rowWithoutReturns = row.replaceAll('\r', '')
    const rowAsList = rowWithoutReturns.split('\t')
    return rowAsList.filter(Boolean)
  },
  readFile: function (file: File): Promise<{ headers: string[], rows: string[][] }> {
    let headers: string[] = []
    let rows: string[][] = []
    const fileReader = new FileReader()
    fileReader.readAsText(file)
    return new Promise((resolve, reject) => {
      fileReader.onload = (event) => {
        const text = event.target?.result
        rows = typeof text === 'string'
          ? text.split('\n').map(row => this.stringRowToArray(row)).filter(row => row.length > 0)
          : []
        headers = rows.shift() || []
        resolve({ headers, rows })
      }
      fileReader.onerror = (error) => reject(error)
    })
  }
}

const FileForTable = {
  getFileExtension: function (file: File) {
    const [ _, extension ] = file.name.split('.')
    return extension
  },
  readExcel: function (file: File, onStartReading: Function) {
    onStartReading()
    return ReadExcel.readFile(file)
  },
  readTSV: function (file: File, onStartReading: Function) {
    onStartReading()
    return ReadTSV.readFile(file)
  }
}

export default FileForTable
export { ReadExcel, FILE_EXTENSION }
